import Icon from '../components/Icon.vue'

Icon.register({
  'headphones-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M160 288H144C108.7 288 80 316.7 80 352.1V415.9C80 451.3 108.7 480 144 480H160C177.7 480 192 465.6 192 447.9V320.1C192 302.4 177.7 288 160 288zM368 288H352C334.3 288 320 302.4 320 320.1V447.9C320 465.6 334.3 480 352 480H368C403.4 480 432 451.3 432 415.9V352.1C432 316.7 403.4 288 368 288zM256 32C112.9 32 4.6 151.1 0 288V400C0 408.8 7.2 416 16 416H32C40.8 416 48 408.8 48 400V288C48 173.3 141.3 80.2 256 80.2 370.7 80.2 464 173.3 464 288V400C464 408.8 471.2 416 480 416H496C504.8 416 512 408.8 512 400V288C507.4 151.1 399.1 32 256 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/headphones-alt.js
// module id = Mtc6
// module chunks = 144